import sumBy from 'lodash/sumBy'
import React from 'react'
import { i18n } from '../../index'
import IndexDisplay from '../IndexDisplay'
import css from './incentiveSales.css'
import type { DailySalesIncentiveReport } from './types'
type IndexSectionProps = {
  data: Array<DailySalesIncentiveReport>
}

const IndexSection = ({ data }: IndexSectionProps) => {
  const totalEuroTarget = Math.round(sumBy(data, 'euroTarget'))
  const totalEuroActual = Math.round(sumBy(data, 'euroActual'))
  // check for zero-denominator, round to 2 decimals
  const euroEfficiency =
    totalEuroTarget > 0 ? (Math.round((totalEuroActual / totalEuroTarget) * 100 * 100) / 100).toFixed(2) : '-'
  return (
    <div>
      <div className={css.rowContainer}>
        <IndexDisplay label={i18n.t('reporting.label.incentiveSales.euroTarget')} value={totalEuroTarget} />
        <IndexDisplay label={i18n.t('reporting.label.incentiveSales.euroActual')} value={totalEuroActual} />
        <IndexDisplay label={i18n.t('reporting.label.incentiveSales.efficiency')} value={euroEfficiency} />
      </div>
    </div>
  )
}

export default IndexSection
